import React from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component';



function Organisation( {organisation} ) {

   
    
return (
    <div className="organisation-items">
        <a 
            href={organisation.properties["Website"]} 
            target="_blank" rel="noreferrer" >

            <div className="organisation-outline">
                <LazyLoadImage src={organisation.properties.Logo} className="organisationImage" alt="" />
                <br/>
                 
                    
                    <div className="p1"> {organisation.properties["Organisation Name"]} </div>
                    <br/>
                    <div className="p2">{organisation.properties.Descriptor}</div>

        
            </div> 
         </a> 
    </div>
)
}
export default Organisation